"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Tue Sep 04 2018
 */

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * SettingsDetailDTOConverter.
 *
 * @author RV
 */


var SettingsDetailDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SettingsDetailDTOConverter, _DataObjectConverter_);

  function SettingsDetailDTOConverter() {
    _classCallCheck(this, SettingsDetailDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SettingsDetailDTOConverter).apply(this, arguments));
  }

  return SettingsDetailDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SettingsDetailDTOConverter = SettingsDetailDTOConverter;